import PropTypes from 'prop-types';
import StyleButton from "./StyleButton";
import { jsx as _jsx } from "react/jsx-runtime";
const BLOCK_TYPES = [{
  label: 'H1',
  style: 'header-one'
}, {
  label: 'H2',
  style: 'header-two'
}, {
  label: 'H3',
  style: 'header-three'
}, {
  label: 'H4',
  style: 'header-four'
}, {
  label: 'H5',
  style: 'header-five'
}, {
  label: 'H6',
  style: 'header-six'
}, {
  label: 'UL',
  style: 'unordered-list-item'
}, {
  label: 'OL',
  style: 'ordered-list-item'
}];
const BlockStyleControls = props => {
  const {
    editorState
  } = props;
  const selection = editorState.getSelection();
  const blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  return /*#__PURE__*/_jsx("div", {
    className: "RichEditor-controls",
    children: /*#__PURE__*/_jsx("div", {
      className: "btn-group",
      role: "group",
      children: BLOCK_TYPES.map(type => /*#__PURE__*/_jsx(StyleButton, {
        active: type.style === blockType,
        label: type.label,
        onToggle: props.onToggle,
        style: type.style
      }, type.label))
    })
  });
};
BlockStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired
};
export default BlockStyleControls;
//# sourceMappingURL=BlockStyleControls.js.map